module.exports = __webpack_public_path__ + "img/ae-gif-2.900e70c.gif";